import React from 'react';
import { InputGroup, InputGroupAddon, UncontrolledTooltip } from 'reactstrap';
import { BasicText, asField } from 'informed';
import classnames from 'classnames';
import Icon from 'react-fa';

export default asField(
  ({
    fieldState,
    field,
    label,
    helpBlock,
    numbers,
    col,
    required,
    leftAddon,
    rightAddon,
    infoBtn,
    infoText,
    onClick,
    onMouseOver,
    ...props
  }) => {
    const infoTarget = `${field}-info`;

    return (
      <div
        className={classnames('form-group', col, {
          required,
          'has-error': fieldState.error
        })}
      >
        <div className="input-span-label-row">
          {label ? <label>{label}</label> : <label />}
          {infoBtn ? (
            <React.Fragment>
              <button
                id={infoTarget}
                type="button"
                className="btn btn-white input-span-info-btn"
                onMouseOver={onMouseOver}
                onClick={onClick}
              >
                <Icon name="info" />
              </button>
              {infoText && (
                <UncontrolledTooltip
                  className="input-span-info-tooltip"
                  placement="top"
                  target={infoTarget}
                  delay={0}
                >
                  {infoText}
                </UncontrolledTooltip>
              )}
            </React.Fragment>
          ) : (
            ''
          )}
        </div>
        <InputGroup className={`form-input ${label ? '' : 'no-label'}`}>
          {leftAddon && (
            <InputGroupAddon addonType="prepend" className="addon-left">
              {' '}
              {leftAddon}{' '}
            </InputGroupAddon>
          )}
          <BasicText
            className="form-control"
            fieldState={fieldState}
            id={field}
            {...props}
          />
          {rightAddon && (
            <InputGroupAddon addonType="append" className="addon-right">
              {' '}
              {rightAddon}{' '}
            </InputGroupAddon>
          )}
        </InputGroup>
        {fieldState.error && (
          <small className={fieldState.error ? 'text-danger' : null}>
            {fieldState.error}
          </small>
        )}
      </div>
    );
  }
);
